import React from 'react';
import PropTypes from 'prop-types';
import { ETLparametersPropTypes, standardPromoETLDefinitionPropTypes } from 'AppModules/Data/Definitions/dataPropTypes';
import { ButtonGroup, Button, Intent, Slider, RangeSlider } from '@blueprintjs/core';
import { capitalize } from 'utils/util';

const RegularPriceParameters = (props) => {
  const regularPriceMethodDefinition = props.ETLdefinition.regularPrice.methods.find((method) => method.name === props.datasetETLparameters.regularPrice.method);

  return (
    <div className="ETLParamDefinition">
      <h4>Regular Price</h4>
      <div className="ETLparam">
        <span className="ETLparamName">Method</span>
        <ButtonGroup>
          {props.ETLdefinition.regularPrice.methods.map((method) => (
            <Button
              key={method.name}
              text={capitalize(method.name)}
              onClick={() => props.handleChangeETLparameter('regularPrice', null, 'method', method.name)}
              intent={method.name === props.datasetETLparameters.regularPrice.method ? Intent.PRIMARY : Intent.NONE}
              active={method.name === props.datasetETLparameters.regularPrice.method}
            />
          ))}
        </ButtonGroup>
      </div>
      {regularPriceMethodDefinition.parameters.map((param) => {
        if (param.type === 'slider') {
          return (
            <div key={param.name} className="ETLparam">
              <span className="ETLparamName">{capitalize(param.name)}</span>
              <Slider
                min={param.range[0]}
                max={param.range[1]}
                stepSize={param.step}
                labelStepSize={param.labelStep || param.step}
                value={props.datasetETLparameters.regularPrice[props.datasetETLparameters.regularPrice.method][param.name]}
                onChange={(newValue) => props.handleChangeETLparameter('regularPrice', props.datasetETLparameters.regularPrice.method, param.name, newValue)}
              />
            </div>
          );
        } if (param.type === 'range-slider') {
          return (
            <div key={param.name} className="ETLparam">
              <span className="ETLparamName">{capitalize(param.name)}</span>
              <RangeSlider
                min={param.range[0]}
                max={param.range[1]}
                stepSize={param.step}
                labelStepSize={param.labelStep || param.step}
                value={props.datasetETLparameters.regularPrice[props.datasetETLparameters.regularPrice.method][param.name]}
                onChange={(newValue) => props.handleChangeETLparameter('regularPrice', props.datasetETLparameters.regularPrice.method, param.name, newValue)}
              />
            </div>
          );
        }
        return null;
      })}
    </div>
  );
};

RegularPriceParameters.propTypes = {
  datasetETLparameters: ETLparametersPropTypes.isRequired,
  handleChangeETLparameter: PropTypes.func.isRequired,
  ETLdefinition: standardPromoETLDefinitionPropTypes.isRequired,
};

export default RegularPriceParameters;
